/* Canonical PSCX Edge module slugs, icon names, and hero artwork class map. */

export const MODULE_SLUGS = [
  "system-catalyst",
  "design-insurance",
  "configuration-compliance",
  "device-lifecycle",
  "license-intelligence",
  "bcdr-solution",
  "knowledge-curation",
  "the-wolf",
] as const;

export type ModuleSlug = (typeof MODULE_SLUGS)[number];

/** Maps a module slug to its ModuleIcon name. */
export const SLUG_TO_ICON: Record<ModuleSlug, string> = {
  "system-catalyst": "catalyst",
  "design-insurance": "insurance",
  "configuration-compliance": "compliance",
  "device-lifecycle": "devices",
  "license-intelligence": "licensing",
  "bcdr-solution": "insurance",
  "knowledge-curation": "knowledge",
  "the-wolf": "wolf",
};

/** Maps slugs and legacy icon aliases to the globals.css hero artwork class. */
export const SLUG_TO_HERO_CLASS: Record<string, string> = {
  "system-catalyst": "catalyst-module-hero",
  catalyst: "catalyst-module-hero",
  "design-insurance": "insurance-module-hero",
  insurance: "insurance-module-hero",
  "communications-insurance": "insurance-module-hero",
  "configuration-compliance": "compliance-module-hero",
  compliance: "compliance-module-hero",
  "device-lifecycle": "devices-module-hero",
  devices: "devices-module-hero",
  "license-intelligence": "license-module-hero",
  licensing: "license-module-hero",
  "bcdr-solution": "bcdr-module-hero",
  bcdr: "bcdr-module-hero",
  "knowledge-curation": "knowledge-module-hero",
  knowledge: "knowledge-module-hero",
  "the-wolf": "wolf-module-hero",
  wolf: "wolf-module-hero",
};
